import { FONTS } from '../neon-theme'

const SCALE = 2
const TEXT_SCALE = 1.1 // 10% larger for mobile readability

export const HEADING_FONT = `bold ${Math.round(11 * SCALE * TEXT_SCALE)}px ${FONTS.body}`
export const SUB_FONT = `${Math.round(8 * SCALE * TEXT_SCALE)}px ${FONTS.body}`
export const HEADING_SIZE = Math.round(11 * SCALE * TEXT_SCALE)
export const SUB_SIZE = Math.round(8 * SCALE * TEXT_SCALE)
export const TITLE_FONT_SIZE = Math.round(24 * SCALE * TEXT_SCALE)
